import { globalPlayerIdAtom, hasUserSelectedPlayerAtom } from '@/atoms/player/player';
import { teamNavigationPlayerLinkIdAtom } from '@/atoms/queries/teams';
import { useAtomValue, useSetAtom } from 'jotai';
import { loadable } from 'jotai/utils';
import { useEffect } from 'react';

/**
 *  This hook sets the `hasUserSelectedPlayerAtom` to true when the user first selects a player
 *  who is not the default player for the user's default team.
 *
 *  The intention of this is to ensure that we do not update all the navigation links
 *  when the user first goes to the player dashboard for the default player.
 *
 *  My thinking here is if your default team is England and you go to the player dashboard for the
 *  default player, if you then go to the team dashboard I would expect it to select England not
 *  the club team of the player.
 * */
export const useSetUserPlayerSelectedAtom = () => {
  const loadableTeamNavigationPlayerLinkId = useAtomValue(loadable(teamNavigationPlayerLinkIdAtom));
  const defaultPlayerId =
    loadableTeamNavigationPlayerLinkId.state === 'hasData' ? loadableTeamNavigationPlayerLinkId.data.datahubId : null;
  const selectedPlayerId = useAtomValue(globalPlayerIdAtom);
  const setHasUserSelectedPlayer = useSetAtom(hasUserSelectedPlayerAtom);

  useEffect(() => {
    if (selectedPlayerId && defaultPlayerId !== selectedPlayerId) setHasUserSelectedPlayer(true);
  }, [defaultPlayerId, selectedPlayerId]);
};
